import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    components: {
      default: Home,
    },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/dashboard',
    // name: 'Dashboard',
    component: () => import('../views/MainPage.vue'),
    children: [
      {
        path: '/',
        components: {
          main: () => import('../components/mainpage/contents/main.vue'),
        },
      },
      {
        path: 'users',
        components: {
          main: () => import('../components/mainpage/contents/users.vue'),
        },
      },
      {
        path: 'user',
        components: {
          main: () => import('../components/mainpage/contents/userDetail.vue'),
        },
      },
      {
        path: 'shop',
        components: {
          main: () => import('../components/mainpage/contents/Shop/shop.vue'),
        },
      },
      {
        path: 'shopdetail',
        components: {
          main: () => import('../components/mainpage/contents/Shop/shopDetail.vue'),
        },
      },
      {
        path: 'shopnew',
        components: {
          main: () => import('../components/mainpage/contents/Shop/shopNewItem.vue'),
        },
      },
      {
        path: 'grounds',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/grounds.vue'),
        },
      },
      {
        path: 'ground',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/ground.vue'),
        },
      },
      {
        path: 'skins',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/skins.vue'),
        },
      },
      {
        path: 'skin',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/skin.vue'),
        },
      },
      {
        path: 'formations',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/formations.vue'),
        },
      },
      {
        path: 'formation',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/formation.vue'),
        },
      },
      {
        path: 'boots',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/boots.vue'),
        },
      },
      {
        path: 'boot',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/boot.vue'),
        },
      },
      {
        path: 'chats',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/chats.vue'),
        },
      },
      {
        path: 'chat',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/chat.vue'),
        },
      },
      {
        path: 'avatars',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/avatars.vue'),
        },
      },
      {
        path: 'avatar',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/avatar.vue'),
        },
      },
      {
        path: 'achievemnt',
        components: {
          main: () => import('../components/mainpage/contents/GameManagment/achievements.vue'),
        },
      },
      {
        path: 'leagues',
        components: {
          main: () => import('../components/mainpage/contents/LeagueManagment/index.vue'),
        },
      },
      {
        path: 'league',
        components: {
          main: () => import('../components/mainpage/contents/LeagueManagment/league.vue'),
        },
      },
      {
        path: 'leagueReport',
        components: {
          main: () => import('../components/mainpage/contents/LeagueManagment/report.vue'),
        },
      },
      {
        path: 'pservices',
        components: {
          main: () => import('../components/mainpage/contents/Setting/paymentServices.vue'),
        },
      },
      {
        path: 'pservice',
        components: {
          main: () => import('../components/mainpage/contents/Setting/paymentService.vue'),
        },
      },
      {
        path: 'purchaseSetting',
        components: {
          main: () => import('../components/mainpage/contents/Setting/purchaseSetting.vue'),
        },
      },
      {
        path: 'licenses',
        components: {
          main: () => import('../components/mainpage/contents/Setting/licenses.vue'),
        },
      },
      {
        path: 'license',
        components: {
          main: () => import('../components/mainpage/contents/Setting/license.vue'),
        },
      },
      {
        path: 'baners',
        components: {
          main: () => import('../components/mainpage/contents/Setting/Banners.vue'),
        },
      },
      {
        path: 'finantial',
        components: {
          main: () => import('../components/mainpage/contents/Finantial/index.vue'),
        },
      },
      {
        path: 'splashes',
        components: {
          main: () => import('../components/mainpage/contents/Setting/Splashes.vue'),
        },
      },
      {
        path: 'splash',
        components: {
          main: () => import('../components/mainpage/contents/Setting/splash.vue'),
        },
      },
      {
        path: 'Gifts',
        components: {
          main: () => import('../components/mainpage/contents/Gift/index.vue'),
        },
      },
      {
        path: 'Gift',
        components: {
          main: () => import('../components/mainpage/contents/Gift/GiftCode.vue'),
        },
      },
      {
        path: 'spinner',
        components: {
          main: () => import('../components/mainpage/contents/Gift/spinner/index.vue'),
        },
      },
      {
        path: 'max',
        components: {
          main: () => import('../components/mainpage/contents/Setting/max.vue'),
        },
      },
      {
        path: 'adSettings',
        components: {
          main: () => import('../components/mainpage/contents/Setting/adSettings.vue'),
        },
      },
      {
        path: 'advertisements',
        components: {
          main: () => import('../components/mainpage/contents/Setting/Advertisements.vue'),
        },
      },
      {
        path: 'advertisements/new',
        components: {
          main: () => import('../components/mainpage/contents/Setting/AdvertisementEdit.vue'),
        },
      },
      {
        path: 'advertisements/:id',
        components: {
          main: () => import('../components/mainpage/contents/Setting/AdvertisementEdit.vue'),
        },
      },
      {
        path: 'lisenceSettings',
        components: {
          main: () => import('../components/mainpage/contents/Setting/licenseSettings.vue'),
        },
      },
      {
        path: 'fake',
        components: {
          main: () => import('../components/mainpage/contents/Setting/fakeIndex.vue'),
        },
      },
      {
        path: 'fakeBot',
        components: {
          main: () => import('../components/mainpage/contents/Setting/fakeBotDetail.vue'),
        },
      },
      {
        path: 'daily',
        components: {
          main: () => import('../components/mainpage/contents/Gift/DailyGift.vue'),
        },
      },
      {
        path: 'publicmessage',
        components: {
          main: () => import('../components/mainpage/contents/messages/index.vue'),
        },
      },
      {
        path: 'UserGroups',
        components: {
          main: () => import('../components/mainpage/contents/Setting/Groups.vue'),
        },
      },
      {
        path: 'UserGroup',
        components: {
          main: () => import('../components/mainpage/contents/Setting/Group.vue'),
        },
      },
      {
        path: 'PaymentSegments',
        components: {
          main: () => import('../components/mainpage/contents/Setting/PaymentTypeSegmentations.vue'),
        },
      },
      {
        path: 'PaymentSegment',
        components: {
          main: () => import('../components/mainpage/contents/Setting/PaymentTypeSegment.vue'),
        },
      },
      {
        path: 'UserRules',
        components: {
          main: () => import('../components/mainpage/contents/Setting/Rules.vue'),
        },
      },
      {
        path: 'UserRule',
        components: {
          main: () => import('../components/mainpage/contents/Setting/Rule.vue'),
        },
      },
      {
        path: 'UserHints',
        components: {
          main: () => import('../components/mainpage/contents/Setting/Hints.vue'),
        },
      },
      {
        path: 'UserHint',
        components: {
          main: () => import('../components/mainpage/contents/Setting/Hint.vue'),
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
